{
  "name": "zwave-js",
  "version": "15.0.6",
  "description": "Z-Wave driver written entirely in JavaScript/TypeScript",
  "keywords": [],
  "type": "module",
  "exports": {
    ".": {
      "@@dev": "./src/index.ts",
      "browser": "./build/esm/index_browser.js",
      "import": "./build/esm/index.js",
      "require": "./build/cjs/index.js"
    },
    "./safe": {
      "@@dev": "./src/index_safe.ts",
      "import": "./build/esm/index_safe.js",
      "require": "./build/cjs/index_safe.js"
    },
    "./Controller": {
      "@@dev": "./src/Controller.ts",
      "import": "./build/esm/Controller.js",
      "require": "./build/cjs/Controller.js"
    },
    "./Driver": {
      "@@dev": "./src/Driver.ts",
      "import": "./build/esm/Driver.js",
      "require": "./build/cjs/Driver.js"
    },
    "./Error": {
      "@@dev": "./src/Error.ts",
      "import": "./build/esm/Error.js",
      "require": "./build/cjs/Error.js"
    },
    "./Node": {
      "@@dev": "./src/Node.ts",
      "import": "./build/esm/Node.js",
      "require": "./build/cjs/Node.js"
    },
    "./Testing": {
      "@@dev": "./src/Testing.ts",
      "import": "./build/esm/Testing.js",
      "require": "./build/cjs/Testing.js"
    },
    "./Utils": {
      "@@dev": "./src/Utils.ts",
      "import": "./build/esm/Utils.js",
      "require": "./build/cjs/Utils.js"
    },
    "./Values": {
      "@@dev": "./src/Values.ts",
      "import": "./build/esm/Values.js",
      "require": "./build/cjs/Values.js"
    },
    "./Zniffer": {
      "@@dev": "./src/Zniffer.ts",
      "import": "./build/esm/Zniffer.js",
      "require": "./build/cjs/Zniffer.js"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "bin/",
    "build/**/*.{js,cjs,mjs,d.ts,d.cts,d.mts,map}",
    "build/**/package.json"
  ],
  "bin": {
    "mock-server": "bin/mock-server.cjs"
  },
  "author": {
    "name": "AlCalzone",
    "email": "d.griesel@gmx.net"
  },
  "license": "MIT",
  "homepage": "https://github.com/zwave-js/zwave-js#readme",
  "repository": {
    "type": "git",
    "url": "git+https://github.com/zwave-js/zwave-js.git"
  },
  "bugs": {
    "url": "https://github.com/zwave-js/zwave-js/issues"
  },
  "funding": {
    "url": "https://github.com/sponsors/AlCalzone/"
  },
  "engines": {
    "node": ">= 20"
  },
  "scripts": {
    "ts": "tsx --conditions=@@dev",
    "codegen": "yarn ts maintenance/codegen.ts",
    "build": "tsc -b tsconfig.build.json --pretty && yarn postbuild",
    "watch": "tsc -b tsconfig.build.json --pretty --watch",
    "postbuild": "yarn esm2cjs --in build/esm --out build/cjs -l error -t node18",
    "clean": "del-cli build/ \"*.tsbuildinfo\"",
    "extract-api": "yarn api-extractor run",
    "lint:ts": "eslint --cache \"src/**/*.ts\"",
    "lint:ts:fix": "yarn run lint:ts --fix",
    "test:ts": "vitest",
    "test:dirty": "tsx ../maintenance/src/resolveDirtyTests.ts --run"
  },
  "dependencies": {
    "@alcalzone/jsonl-db": "^3.1.1",
    "@andrewbranch/untar.js": "^1.0.3",
    "@homebridge/ciao": "^1.3.1",
    "@zwave-js/cc": "workspace:*",
    "@zwave-js/config": "workspace:*",
    "@zwave-js/core": "workspace:*",
    "@zwave-js/host": "workspace:*",
    "@zwave-js/nvmedit": "workspace:*",
    "@zwave-js/serial": "workspace:*",
    "@zwave-js/shared": "workspace:*",
    "@zwave-js/testing": "workspace:*",
    "alcalzone-shared": "^5.0.0",
    "ansi-colors": "^4.1.3",
    "ky": "^1.7.2",
    "mdns-server": "^1.0.11",
    "p-queue": "^8.0.1",
    "pathe": "^2.0.1",
    "reflect-metadata": "^0.2.2",
    "semver": "^7.6.3",
    "serialport": "^13.0.0",
    "source-map-support": "^0.5.21",
    "winston": "^3.17.0"
  },
  "devDependencies": {
    "@alcalzone/esm2cjs": "^1.4.1",
    "@microsoft/api-extractor": "^7.52.2",
    "@types/node": "^20.17.16",
    "@types/semver": "^7.5.8",
    "@types/sinon": "^17.0.3",
    "@types/source-map-support": "^0.5.10",
    "@zwave-js/maintenance": "workspace:*",
    "@zwave-js/transformers": "workspace:*",
    "del-cli": "^6.0.0",
    "mockdate": "^3.0.5",
    "sinon": "^19.0.2",
    "tsx": "^4.19.2",
    "typescript": "5.7.3",
    "vitest": "^2.1.9"
  }
}
